import React from 'react';
import { InfoIcon } from 'lucide-react';
import { audiences } from '../../data/landing';
import { CtaButton } from '../CtaButton';
export function AudienceSection() {
  return <section className="bg-cream py-12 sm:py-24" data-id="element-80" data-mp="96faegowz1p8">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-81" data-mp="954a4quogc2v">
        <div className="mx-auto max-w-2xl text-center" data-id="element-82" data-mp="47kjergsm6u1">
          <h2 className="font-serif text-[1.9rem] text-petrol-800 sm:text-5xl" data-id="element-83" data-mp="4841q9acux8l">
            ¿Este kit es <span className="italic text-terra-500" data-id="element-84" data-mp="3cnnp4rochlfq">para vos?</span>
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-ink/70 sm:mt-5 sm:text-lg" data-id="element-85" data-mp="38mkeqkp2ghlw">
            Pensado para <strong className="text-petrol-800" data-id="element-86" data-mp="3mdph3ujtjnzx">profesionales que trabajan con sexualidad</strong>   que buscan sumar herramientas prácticas y agilizar su forma de trabajar.
          </p>
        </div>

        <ul className="mt-7 grid grid-cols-2 gap-2.5 sm:mt-12 sm:gap-4 lg:grid-cols-4" data-id="element-87" data-mp="2tvbpicp2sy9a">
          {audiences.map(({
          label,
          icon: Icon
        }) => <li key={label} className="group flex flex-col rounded-2xl bg-sage-100 p-4 transition-colors duration-150 ease-out hover:bg-petrol-800 sm:p-6" data-id="element-88" data-mp="3co2k87p5gai1">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-petrol-700 text-cream transition-colors duration-150 ease-out group-hover:bg-terra-500 sm:h-11 sm:w-11" data-id="element-89" data-mp="3hl1f4sgn0lha">
                <Icon className="h-4 w-4 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-90" data-mp="3rc5uvue50ad6" />
              </span>
              <p className="mt-3 font-serif text-[15px] leading-snug text-petrol-800 transition-colors duration-150 ease-out group-hover:text-cream sm:mt-6 sm:text-xl" data-id="element-91" data-mp="2tqhxp79uxo0l">
                {label}
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-5 flex max-w-2xl items-start justify-center gap-2 text-center text-xs leading-relaxed text-ink/55 sm:mt-8 sm:text-[13px]" data-id="element-92" data-mp="37oq0vwxhllk7">
          <InfoIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-93" data-mp="iwcah4goqequ" />
          El contenido funciona como material de apoyo profesional y no reemplaza formación, supervisión ni criterio
          profesional.
        </p>

        <div className="mt-7 flex justify-center sm:mt-10" data-id="element-94" data-mp="2k0xyw4j5rxc6">
          <CtaButton className="w-full sm:w-auto" data-id="element-95" data-mp="2ezig6j4ge2wy" />
        </div>
      </div>
    </section>;
}